import { SlotBox } from '@packages/shared';
import type { ReactNode } from 'react';

export type SlotBoxDVProps = {
  children: ReactNode;
};

export const SlotBoxDV = ({ children }: SlotBoxDVProps) => (
  <SlotBox sx={{ p: 2, pb: 2 }}>{children}</SlotBox>
);
